export type BackendLogLevel = 'error' | 'warn' | 'info' | 'debug' | 'log';
export type DispatchLog = (error: unknown, level?: BackendLogLevel, options?: Record<string, unknown>) => void;

let logDispatch: DispatchLog | null = null;

export function setBackendLogDispatch(dispatch: DispatchLog | null) {
    logDispatch = dispatch;
}

export function getBackendLogDispatch(): DispatchLog | null {
    return logDispatch;
}
